module.exports = {
  key: '8b218b85545392c9f8705c30fbfd1bce',
};
